import React, { Component } from 'react';
import { Box, Dialog, DialogTitle, DialogContent, DialogActions, DialogProps, DialogTitleProps, DialogContentProps, DialogActionsProps, Breakpoint, Grid, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import IbssIconButton from '../../Buttons/IconButton/IbssIconButton';
import './Styles.scss';
import ErrorImage from './Error.svg';

export default class IbssDialog extends Component<IProps>
{

    public render(): JSX.Element
    {
        const props = this.props;
        const styleName = props.styleName ?? 'default';

        return (
        <Dialog maxWidth={props.maxWidth} {...props} className={`ibss-dialog--${styleName}`}>
        <Grid container direction="row">
            <Grid
                item
                className="ibss-dialog__main"
                flexGrow={1}
            >
               <Grid container>
                 {styleName === "error" && props.header &&
                 <>
                    <Grid xs={1}
                        item
                        className="ibss-dialog__icon"
                        >
                        <img src={ErrorImage} />
                    </Grid>
                    <Typography variant='h6'sx={{pt:2,pl:2}}>{props.header}</Typography>
                    </>
                }
                {
                    styleName === "default" && props.header &&
                    <Grid
                        xs={12}
                        item>
                        <Box className="ibss-dialog__header" >
                            <Typography variant='h6'>{props.header}</Typography>
                            {props.onClose &&
                                <IbssIconButton aria-label="close" onClick={props.onClose}>
                                    <CloseIcon />
                                </IbssIconButton>
                            }
                        </Box>
                        </Grid>}
                        </Grid>

                <Box className={props.customClass ? props.customClass : "ibss-dialog__content"} sx={{maxHeight:'calc(100vh - 246px)'}}>
                    {props.dialogContent}
                </Box>
                {
                    props.footer &&
                    <Box className="ibss-dialog__footer">
                        {props.footer}
                    </Box>
                }
            </Grid>
        </Grid>
    </Dialog>
        );
    }
}

export interface IProps extends DialogProps
{
    styleName?: DialogStyle;
    header?: React.ReactNode;
    dialogContent: React.ReactNode;
    footer?: React.ReactNode;
    maxWidth?: Breakpoint;
    onClose?: () => void;
    customClass?: string;
}

export type DialogStyle = 'default' | 'error';
